module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/chevron-right.svg?a400f1ee5959083eeabab0adb5204e92";